import { createSupportLoggingMutationCache, createSupportLoggingQueryCache } from '@peritasai/support-logging';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    queryCache: createSupportLoggingQueryCache({ serviceName: 'periverse_app', source: 'periverse' }),
    mutationCache: createSupportLoggingMutationCache({ serviceName: 'periverse_app', source: 'periverse' }),
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        retry: 1,
      },
    },
  });
}

export function QueryProvider({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => createQueryClient());
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}
